import { apiClient } from "@/api/client";
import type { ListQuery, Paginated } from "@/types/common";
import type { Driver, DriverProfile, DriverStatus } from "@/types/domain";

/** Talks to apps/admin-service (people.service.ts listDrivers/driverProfile/setDriverStatus). */
export const driversApi = {
  /** GET /admin/drivers — page, limit, status, kyc, search, online. */
  list: (query: ListQuery & { status?: DriverStatus; kyc?: string; online?: boolean }) =>
    apiClient.get<Paginated<Driver>>("/admin/drivers", { params: query }).then((r) => r.data),

  /** GET /admin/drivers/:id — full profile incl. vehicle, wallet, ranking, recent rides. */
  getById: (id: string) =>
    apiClient.get<DriverProfile>(`/admin/drivers/${id}`).then((r) => r.data),

  /**
   * PATCH /admin/drivers/:id/status — ADMIN/OPERATIONS only. Same endpoint
   * handles every DriverStatus transition (suspend, reactivate to ACTIVE, etc).
   */
  setStatus: (id: string, status: DriverStatus, reason?: string) =>
    apiClient
      .patch<Driver>(`/admin/drivers/${id}/status`, { status, reason })
      .then((r) => r.data),
};
